import Vue from 'vue';
import moment from 'moment';
import { Component } from 'vue-property-decorator';

@Component
export default class CurrentTimeMixin extends Vue {
  dateNow: Date = new Date();
  interval: number;
  get currentDate() {
    if (this.$i18n.locale === 'ja')
      return moment(this.dateNow).format('YYYY.MM.DD');
    return moment(this.dateNow).format('DD.MM.YYYY');
  }
  get currentDayOfWeek() {
    return moment(this.dateNow).format('ddd');
  }
  get currentTime() {
    return moment(this.dateNow).format('HH:mm:ss');
  }
  mounted() {
    this.interval = setInterval(() => {
      this.dateNow = new Date();
    }, 1000);
  }
  destroy() {
    clearInterval(this.interval);
  }
}
